import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Heading,
    Title,
    DesktopSubHeader,
    DesktopHeader,
} from './InventoryHeader.styled';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft.svg';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { setProgressBarStatus } from 'src/pages/consignmentReturn/redux/actions';
import {
    accountNumberZeroTrimmer,
    getRoutePathWithParams,
    logErrorToConsole,
} from 'src/utils/util';

const InventoryHeader = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { accountId, patientFirstName, patientLastName, physicianName } =
        useSelector((state) => ({
            accountId: state.consignmentReturnReducer.surgeryDetails.accountId,
            patientFirstName:
                state.consignmentReturnReducer.surgeryDetails.patientFirstName,
            patientLastName:
                state.consignmentReturnReducer.surgeryDetails.patientLastName,
            physicianName:
                state.consignmentReturnReducer.surgeryDetails.physicianId,
        }));

        const isCondensedView = useSelector(
            (state) => state.loginReducer.isCondensedView
        );
    return (
        <>
            <DesktopHeader>
                <img
                    src={BackIcon}
                    alt="back"
                    id={`back-btn-${accountId?.accountId ?? 'unknown'}`}
                    onClick={() => {
                        try {
                            history.push({
                                ...getRoutePathWithParams('/consignmentReturn'),
                                // state: {
                                //     detail: {
                                //         accountId: accountId.accountId,
                                //         patientFirstName: patientFirstName,
                                //         patientLastName: patientLastName,
                                //         physicianName: physicianName,
                                //         accountName: accountId.accountName,
                                //         hrefId: hrefId,
                                //     },
                                // },
                            });
                            dispatch(setProgressBarStatus('Account'));
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    style={{
                        cursor: 'pointer',
                    }}
                />

                <DesktopSubHeader marginLeft = {isCondensedView ? '28%' : 'auto'}>
                    <Title>
                        {t(
                            'consignmentReturn.inventory.addFromConsignmentInventory'
                        )}
                    </Title>
                </DesktopSubHeader>
                <div
                    id="consignmentReturn-inventoryHeader-pii"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                    }}
                >
                    <Heading isDemi>
                        {accountId?.accountName}{' '}
                        <Heading isRegular>
                            {accountNumberZeroTrimmer(
                                accountId?.accountId || ''
                            )}
                        </Heading>
                    </Heading>

                    <Heading isDemi style={{ marginTop: 'unset' }}>
                        {physicianName
                            ? `${t('common.drLabel')} ${physicianName}`
                            : ''}
                        {patientFirstName && (
                            <Heading isRegular>
                                {' '}
                                {patientFirstName && physicianName && (
                                    <span style={{ paddingLeft: '4px' }}>
                                        |
                                    </span>
                                )}{' '}
                                <span style={{ paddingLeft: '4px' }}>
                                    {t('consignmentReturn.inventory.patient')}
                                </span>{' '}
                                {patientFirstName + ' ' + patientLastName}{' '}
                            </Heading>
                        )}
                    </Heading>
                </div>
            </DesktopHeader>
        </>
    );
};

export default InventoryHeader;
